import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useCoinContext } from '../../contexts/CoinContext';
import { useUserContext } from '../../contexts/UserContext';
import { loginUrl } from '../../lib/login';
import { useCoinModalContext } from '../../contexts/CoinModalContext';

const CoinsTooltip = ({ children }: PropsWithChildren<object>) => {
  const userContext = useUserContext();
  const coinContext = useCoinContext();
  const coinModalContext = useCoinModalContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [shown, setShown] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shown) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [shown]);

  const showTooltip = () => {
    setShown(true);
  };

  const onGetMore = (e: React.MouseEvent) => {
    e.preventDefault();

    if (userContext.isLoggedIn()) {
      coinModalContext.showMenuModal({});
    } else {
      navigate(loginUrl(location.pathname + location.search));
    }

    setShown(false);
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
      setShown(false);
    }
  };

  const balance = coinContext.getBalance();

  let getMoreText: string;
  if (userContext.isLoggedIn()) {
    getMoreText = 'Get more!';
  } else {
    getMoreText = 'Log in to get more!';
  }

  return <TooltipWrapper onClick={showTooltip}>
    {shown ? <Tooltip ref={tooltipRef}>
      You have {balance} coin{balance === 1 ? '' : 's'}.
      <GetMore onClick={onGetMore}>{getMoreText}</GetMore>
    </Tooltip> : null}
    {children}
  </TooltipWrapper>;
};

const TooltipWrapper = styled.span`
  display: contents;
  cursor: pointer;
`;

const Tooltip = styled.div`
  position: absolute;
  background: #fff;
  border: 1px solid #333;
  border-radius: 3px;
  color: #000;
  padding: 5px;
  top: 55px;
  transform: translate(-30px, 0);
  cursor: default;
  z-index: 50;
`;

const GetMore = styled.a`
  cursor: pointer;
  text-decoration: underline;
  margin-top: 1em;
`;

export default CoinsTooltip;
